import crypto from 'crypto';

/**
 * Generate a hex converted 2-sized string based on given decimal value
 * @param {Object} dec
 * @returns {str} hex converted part of given string
 */
const dec2hex = dec => {
  return ('0' + dec.toString(16)).slice(-2);
}

/**
 * Generate an array with strong random base64 encoded values and return it as a string
 * @returns {str} verifier
 */
export const generateVerifier = () => {
  const array = new Uint32Array(56/2);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec2hex).join('');
}

/**
 * 
 * @param {str} plain: verifier as a string 
 * @returns {ArrayBuffer} hashed value with SHA-256
 */
export const sha256 = plain => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

/**
 * Transform using S256 as recommended by RFC7636
 * @param {ArrayBuffer} a: hashed code verifier
 * @returns {str} base64 encoded string
 */
export const base64UrlEncode = a => {
  let str = "";
  let bytes = new Uint8Array(a);
  let len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return Buffer.from(str).toString('base64').replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/**
 * Generate a code challenge from code verifier
 * @param {str} v: verifier
 * @returns {str} challenge
 */
export const generateChallenge = async v => {
  const hashed = await sha256(v);
  const challenge = base64UrlEncode(hashed);
  return challenge;
}

//NOTE: For verifying purposes
export const verifyValidity = (verifier, challenge) => {
  const base64 = crypto.createHash('sha256').update(verifier).digest('base64');
  const base64UriEncoded = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return base64UriEncoded === challenge;
};